const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const formatDate = (date: string | number | Date, formatDaysNamesInShort = false) => {
  const dateObj = new Date(date);
  const dayNames = formatDaysNamesInShort
    ? ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"]
    : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const month = dateObj.getMonth();
  const h = dateObj.getHours();
  const m = dateObj.getMinutes();

  return {
    day: dateObj.getDate()?.toString() || "",
    monthShort: monthNames[month]?.slice(0, 3) || "",
    weekDayShort: dayNames[dateObj?.getDay()]?.slice(0, 3) || "",
    monthLong: monthNames[month] || "",
    weekDayLong: dayNames[dateObj.getDay()] || "",
    year: dateObj.getFullYear() || "",
    monthNumber: month + 1 < 10 ? `0${month + 1}` : `${month + 1}`,
    hours: h < 10 ? `0${h}` : `${h}`,
    minutes: m < 10 ? `0${m}` : `${m}`,
    meridiem: h >= 12 ? "PM" : "AM",
  };
};

export default formatDate;
